import { render, staticRenderFns } from "./ElementStudioAlertBoxOptions.vue?vue&type=template&id=b89503c4&"
import script from "./ElementStudioAlertBoxOptions.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioAlertBoxOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports